// Footer link groups (settings.footer.links) hold marketing-website paths.
// Outside the marketing website (e.g. the platform) those routes don't exist,
// so links must point at the marketing website origin instead.
export default function getFooterLinkHref({
  isMarketingWebsite,
  locale,
  href,
}: {
  isMarketingWebsite: boolean;
  locale: string;
  href: string;
}): string {
  if (isMarketingWebsite) {
    return `/${locale}${href}`;
  }

  return `${process.env.NEXT_PUBLIC_LINK_MARKETING_WEBSITE ?? '/'}${locale}${href}`;
}
